import { useCallback } from "react";
var SCROLL_OFFSET = 0;
var SCROLL_DURATION = 100;
/**
 * 滚动到指定元素
 */
function scrollToElement(element, to, duration) {
    if (duration <= 0) {
        element.scrollTop = to;
        return;
    }
    var difference = to - element.scrollTop;
    var perTick = (difference / duration) * 10;
    requestAnimationFrame(function () {
        element.scrollTop += perTick;
        if (element.scrollTop === to)
            return;
        scrollToElement(element, to, duration - 10);
    });
}
export function useListScroll(selectRef) {
    /**
     * 滚动到当前选择元素
     */
    var scrollTo = useCallback(function (index, offset, duration) {
        if (offset === void 0) { offset = SCROLL_OFFSET; }
        if (duration === void 0) { duration = SCROLL_DURATION; }
        var element = selectRef.current;
        if (!element) {
            return;
        }
        var topOption = element.children[index];
        if (!topOption) {
            return;
        }
        var to = topOption.offsetTop - element.offsetTop - offset;
        scrollToElement(element, to, duration);
    }, [selectRef]);
    return scrollTo;
}
//# sourceMappingURL=use-list-scroll.js.map